import React from 'react'

export const NotFound = () => (
  <p>
    La page demandée n&apos;existe pas.
  </p>
)

export default NotFound
